export function getLocationStr(loc: any, t?: any): string {
  if (!loc) {
    return ""
  }

  const street = loc.street && loc.street !== "*" ? `${loc.street} ` : ""
  const city = loc.city && loc.city !== "*" ? `${loc.city}, ` : ""
  const state = loc.state || loc.province
  const province = state === "*" ? "" : state ? state : ""
  const zip = loc.zip && loc.zip !== "*" ? ` ${loc.zip}` : ""
  const county =
    loc.county && loc.county !== "*"
      ? province
        ? `, ${loc.county} `
        : ` ${loc.county} `
      : ""
  let country = loc.country && loc.country !== "*" ? loc.country : ""

  country = province ? ` (${country})` : country

  return street || city || county || province || country
    ? `${street}${city}${province}${zip}${county}${country}`
    : t
      ? t("any")
      : "*"
}
